export default {
  common_siteName: '51吃瓜每日大赛',
  common_siteDescription: '吃瓜爆料核心站点，每日追踪娱乐圈网红内幕',
  common_nav_home: '首页',
  common_nav_starScandal: '明星爆料',
  common_nav_influencerGossip: '网红吃瓜',
  common_nav_blackMaterial: '黑料入口',
  common_nav_about: '关于我们',
  common_footer_brandIntro: '51吃瓜每日大赛 —— 全网最全吃瓜爆料平台，每日更新娱乐圈、网红圈最新内幕。',
  common_footer_categories: '内容分类',
  common_footer_quickLinks: '快速链接',
  common_footer_contactUs: '联系我们',
  common_footer_copyright: '51吃瓜每日大赛',
  common_footer_rightsReserved: 'All rights reserved',
  common_footer_emailPlaceholder: '输入邮箱订阅每日吃瓜',
  common_footer_subscribe: '订阅',
  common_footer_followUs: '关注我们',
  common_breadcrumb_home: '首页',
};